import { createRouter, createWebHistory } from 'vue-router';
import getSharedData from '@menu/Utils/getSharedData';
import { routes } from '@menu/Router/routes';
import { localize, setCurrentLanguageCode } from '@menu/Utils/i18n';
import { setPreferredLanguage } from '@menu/Utils/preferredLanguage';
import getRestaurant from '@menu/Utils/getRestaurant';
import getMenuBySlug from '@menu/Utils/getMenuBySlug';

export const router = createRouter({
  history: createWebHistory(getSharedData().routerBase),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.afterEach((to) => {
  if (typeof to.params.languageCode === 'string') {
    setCurrentLanguageCode(to.params.languageCode);
    setPreferredLanguage(to.params.languageCode);
  }

  document.title = to.params.menuSlug
    ? `Menu - ${getRestaurant().name} - ${localize(getMenuBySlug(to.params.menuSlug as string).name)}`
    : `Menu - ${getRestaurant().name}`;
});
